import { Flex } from '@components/grid';
import { P } from '@components/typography/new';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'motion/react';
import { colors, RECOMMENDATION_ENGINE } from '@nandosaus/constants';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { useField } from 'formik';
import { forwardRef } from 'react';
import { useIsMinWidth } from '@hooks/use-is-min-width';
import { Section, ErrorMessage } from '../../ui';
import { QuestionHeader } from '../components';

const { mealTypes } = RECOMMENDATION_ENGINE;

export const SelectMealType = forwardRef((props, ref) => {
  const isTablet = useIsMinWidth('md');
  const validateMealType = mealType => (mealType ? undefined : 'Required');
  const [field, meta, helper] = useField({ name: 'mealType', validate: validateMealType });
  const { error, touched } = meta;
  const { setValue, setTouched } = helper;
  const mealType = field.value;
  const description = mealType ? Object.values(mealTypes).find(type => type.value === mealType).description : null;
  return (
    <>
      <Section ref={ref}>
        <QuestionHeader
          title="How are y’all feeling?"
          description="Are you keen to indulge or prefer to keep it balanced?"
          required
        />
        {error && touched && <ErrorMessage>{error}</ErrorMessage>}
        <ToggleGroupRoot
          type="single"
          aria-label="Diet preference"
          value={mealType}
          onValueChange={value => {
            if (value) {
              setTouched(true, false);
              setValue(value);
            }
          }}
        >
          <ToggleGroupItem value={mealTypes.healthy.value} aria-label={mealTypes.healthy.ariaLabel}>
            <StyledP variant="medium-bold">{mealTypes.healthy.label}</StyledP>
          </ToggleGroupItem>
          <ToggleGroupItem value={mealTypes.balanced.value} aria-label={mealTypes.balanced.ariaLabel}>
            <StyledP variant="medium-bold">{mealTypes.balanced.label}</StyledP>
          </ToggleGroupItem>
          <ToggleGroupItem value={mealTypes.indulgent.value} aria-label={mealTypes.indulgent.ariaLabel}>
            <StyledP variant="medium-bold">{mealTypes.indulgent.label}</StyledP>
          </ToggleGroupItem>
        </ToggleGroupRoot>
        <AnimatePresence>
          {mealType && (
            <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }}>
              <Flex mb="14px">
                <P variant="medium">{description}</P>
              </Flex>
              <StyledMealTypeImageDiv src={mealTypes[mealType].bannerImageWeb} isTablet={isTablet} />
            </motion.div>
          )}
        </AnimatePresence>
      </Section>
      <Flex height="4px" width="200%" backgroundColor="warmWhite3" mx="-50px" />
    </>
  );
});

const StyledMealTypeImageDiv = styled.div`
  border-radius: 8px;
  background-image: ${({ src }) => `url(${src})`};
  background-position: center;
  background-size: cover;
  transition: all 0.3s ease-in-out;
  aspect-ratio: 3.1 / 1;
`;

const StyledP = styled(P)`
  font-size: 16px !important;
  line-height: 1.2 !important;
`;

const ToggleGroupRoot = styled(ToggleGroup.Root)`
  border: 1px solid black;
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;

const ToggleGroupItem = styled(ToggleGroup.Item)`
  padding: 18.5px 20px;
  color: black;
  &:not(:last-child) {
    border-right: 1px solid ${colors.grey30};
  }
  &[data-state='on'] {
    color: white;
    background-color: black;
    border-right: 1px solid black;
  }
`;
